import React from "react";
import { useParams } from "react-router-dom";
import RichCoursePage from "./RichCoursePage";
import CoursePage from "./CoursePage";
import { FLAGSHIP_COURSES } from "../data/flagshipCourses";
import { EXPANSION_COURSES } from "../data/expansionCourses";

// Flagship + expansion slugs render the rich, fully-furnished course experience.
// Any other slug falls back to the legacy course template (draft content).
const RICH_COURSES = [...FLAGSHIP_COURSES, ...EXPANSION_COURSES];

export default function CourseRoute() {
  const { slug } = useParams();
  const rich = RICH_COURSES.find((c) => c.slug === slug);
  if (rich) return <RichCoursePage course={rich} />;
  return <CoursePage />;
}
